import { AcademieReport } from '../../types/academieReport';
import { X, Download } from 'lucide-react';
import { exportAcademieReportPdf } from '../../utils/exportPdf';

interface AcademieReportPreviewProps {
  report: AcademieReport;
  onClose: () => void;
}

export function AcademieReportPreview({ report, onClose }: AcademieReportPreviewProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">Rapport Académie - {new Date(report.date).toLocaleDateString('fr-FR')}</h2>
          <div className="flex items-center gap-2">
            <button
              onClick={() => exportAcademieReportPdf(report)}
              className="flex items-center gap-2 px-3 py-1.5 bg-[#00665C] text-white text-sm rounded-lg hover:bg-[#004d45] transition-colors"
            >
              <Download size={16} />
              <span className="hidden sm:inline">PDF</span>
            </button>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
              <X size={20} />
            </button>
          </div>
        </div>
        
        <div className="p-6 space-y-6">
          <section>
            <h3 className="text-lg font-medium text-gray-900 mb-4">Informations Générales</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">Date du rapport</p>
                <p className="font-medium">{new Date(report.date).toLocaleDateString('fr-FR')}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Classe</p>
                <p className="font-medium">{report.className}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Effectif réel</p>
                <p className="font-medium">{report.actualStudents}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Effectif présent</p>
                <p className="font-medium">{report.presentStudents}</p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm text-gray-500">Modérateur du jour</p>
                <p className="font-medium">{report.moderator}</p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm text-gray-500">Cours du jour</p>
                <p className="font-medium">{report.courseOfTheDay}</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-medium text-gray-900 mb-4">Observations</h3>
            <div className="space-y-4">
              <div>
                <p className="text-sm text-gray-500">Atmosphère spirituelle de la classe</p>
                <p className="whitespace-pre-wrap font-medium">{report.spiritualAtmosphere || 'RAS'}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Participation de la classe</p>
                <p className="whitespace-pre-wrap font-medium">{report.classParticipation || 'RAS'}</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-medium text-gray-900 mb-4">Prochaines activités</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">Prochain cours</p>
                <p className="font-medium">{report.nextCourse || '-'}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Prochain modérateur</p>
                <p className="font-medium">{report.nextModerator || '-'}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Méditation prochaine</p>
                <p className="font-medium">{report.nextMeditation || '-'}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Exercice prochain</p>
                <p className="font-medium">{report.nextExercise || '-'}</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}